const state = {
  username: 'test'
}

const mutations = {
  add (state) {
    state.username = state.username + 'ttt'
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/test.js